export default __webpack_public_path__ + "static/media/camerascreenlinear.ea34d75a.svg";